import { render, staticRenderFns } from "./ReportV3.vue?vue&type=template&id=f27b080a&scoped=true&"
import script from "./ReportV3.vue?vue&type=script&lang=js&"
export * from "./ReportV3.vue?vue&type=script&lang=js&"
import style0 from "./ReportV3.vue?vue&type=style&index=0&id=f27b080a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27b080a",
  null
  
)

export default component.exports